import { render, staticRenderFns } from "./OrderItemsList.vue?vue&type=template&id=26556776&scoped=true"
import script from "./OrderItemsList.vue?vue&type=script&lang=ts"
export * from "./OrderItemsList.vue?vue&type=script&lang=ts"
import style0 from "./OrderItemsList.vue?vue&type=style&index=0&id=26556776&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26556776",
  null
  
)

export default component.exports